var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 34.4551H18C12 34.4551 9 32.9551 9 25.4551V17.9551C9 11.9551 12 8.95508 18 8.95508H30C36 8.95508 39 11.9551 39 17.9551V25.4551C39 31.4551 36 34.4551 30 34.4551H29.25C28.785 34.4551 28.335 34.6801 28.05 35.0551L25.8 38.0551C24.81 39.3751 23.19 39.3751 22.2 38.0551L19.95 35.0551C19.71 34.7251 19.17 34.4551 18.75 34.4551Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 26.174C17.7152 26.174 17.4302 26.069 17.2052 25.844L14.2052 22.844C13.7702 22.409 13.7702 21.689 14.2052 21.254L17.2052 18.254C17.6402 17.819 18.3602 17.819 18.7952 18.254C19.2302 18.689 19.2302 19.409 18.7952 19.844L16.5902 22.049L18.7952 24.254C19.2302 24.689 19.2302 25.409 18.7952 25.844C18.5702 26.069 18.2852 26.174 18.0002 26.174Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 26.174C29.7152 26.174 29.4302 26.069 29.2052 25.844C28.7702 25.409 28.7702 24.689 29.2052 24.254L31.4102 22.049L29.2052 19.844C28.7702 19.409 28.7702 18.689 29.2052 18.254C29.6402 17.819 30.3602 17.819 30.7952 18.254L33.7952 21.254C34.2302 21.689 34.2302 22.409 33.7952 22.844L30.7952 25.844C30.5702 26.069 30.2852 26.174 30.0002 26.174Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4996 26.6697C22.3496 26.6697 22.1996 26.6396 22.0496 26.5796C21.4796 26.3396 21.2096 25.6796 21.4646 25.0946L24.4646 18.0896C24.7046 17.5196 25.3645 17.2496 25.9495 17.5046C26.5195 17.7446 26.7896 18.4046 26.5346 18.9896L23.5346 25.9946C23.3546 26.4146 22.9346 26.6697 22.4996 26.6697Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCode);
export default __webpack_public_path__ + "static/media/messageCode.54f6674c8a7c3808cd4f591f6f7830b0.svg";
export { ForwardRef as ReactComponent };